let languageCode = 'cmn';
module.exports = {
	languageCode,
	endonym: '中文',
	displayValue: 'Chinese (Mandarin)',
	raadELLPurpose: '文字是人类获取知识的地方。你将通过阅读这些文章来增长你的知识。同时，你也会增加你的词汇量，提高阅读能力，每天都享受阅读！',
	raadELLPurposeAudio: '/assets/dist/audio/set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'这些文章充满了大量知识。通过阅读，你会学到许多新的和重要的东西。你可能不明白很多你读的东西。那很好！因为阅读是你学习新的东西的一种方式。而当你学到一些新东西时，就会更容易学到更多的新东西！也许你已经知道这些文章中的一些知识，这也很好，因为当你阅读更多关于你已经知道的内容时，将会增加你的词汇量，并帮助你学习新的，更广大的知识领域。最后，通过阅读这些文章，你会成为一个很強的读者，并能够坚持长期的阅读。祝阅读快乐！',
	raadELLMindsetAudio: '',
	raadELLChooseOne: '现在请选择一篇文章阅读。',
	raadELLChooseOneAudio: '/assets/dist/audio/aad_instructions_' + languageCode + '.mp3',
	raadELLBOKDirectionsLabel: '说明:',
	raadELLBOKWrite: '请写下你想要记住的，在文章中学到的2或3样东西。',
	raadELLBOKWriteAudio: '/assets/dist/audio/bok_instructions_' + languageCode + '.mp3'
};
